import type { JsonSchemaType } from '@gmn-portal/backend';
import type { UseFormReturn } from 'react-hook-form';
import type { z } from 'zod';
import AutoFormObject from '@/shared/components/ui/auto-form/fields/object';

import type { FieldConfig, FieldConfigItem } from '../ui/auto-form/types';

type MetadataAutoFormProps = {
  schema: z.ZodObject<any>;
  form: UseFormReturn<any, any, any>;
  path?: string[];
  disabled?: boolean;
  metadataSchema?: JsonSchemaType;
  groupKey?: string | null;
  disableGrouping?: boolean;
};

type ExtendedFieldConfigItem = FieldConfigItem & {
  metadataSchema?: JsonSchemaType;
  groupKey?: string | null;
};

export function MetadataAutoForm({
  schema,
  form,
  path,
  disabled,
  metadataSchema,
  groupKey,
  disableGrouping,
}: MetadataAutoFormProps) {
  const fieldConfig: FieldConfig<z.infer<typeof schema>> = {
    '*': {
      inputProps: {
        disabled,
      },
      metadataSchema,
      groupKey,
    } as ExtendedFieldConfigItem,
  };

  return (
    <AutoFormObject
      schema={schema}
      form={form}
      path={path}
      fieldConfig={fieldConfig}
      metadataSchema={metadataSchema}
      disableGrouping={disableGrouping}
    />
  );
}
